import { render } from "./SettingsMain.vue?vue&type=template&id=f0c4d2ca&scoped=true&lang=true"
import script from "./SettingsMain.vue?vue&type=script&lang=js"
export * from "./SettingsMain.vue?vue&type=script&lang=js"

import "./SettingsMain.vue?vue&type=style&index=0&id=f0c4d2ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0c4d2ca"

export default script